import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

const aboutOrgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩国漫画网',
  url: 'http://rldcigr.com/',
  description: '免费韩漫大全资源导航站，提供便捷的韩漫在线阅读入口',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'hello@rldcigr.com',
    availableLanguage: ['Chinese'],
  },
};

const aboutPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于我们 - 韩国漫画网',
  description: '了解韩国漫画网——您的免费韩漫大全资源导航站，品牌介绍、用户口碑与联系方式',
  url: 'http://rldcigr.com/about',
};

export default function AboutPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutOrgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutPageSchema) }}
      />

      <Navbar />
      <main>
        <section className="pt-24 pb-4 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </section>

        <section className="relative h-[500px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20library%20with%20floating%20colorful%20comic%20book%20covers%20in%20soft%20ambient%20light%20clean%20contemporary%20workspace%20aesthetic%20warm%20neutral%20tones%20artistic%20atmosphere%20peaceful%20composition&width=1400&height=600&seq=about-hero-01&orientation=landscape"
            alt="韩国漫画网品牌形象"
            title="韩国漫画网 - 免费韩漫大全品牌"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
          <div className="absolute inset-0 flex items-end pb-16">
            <div className="max-w-7xl mx-auto px-4 md:px-6 w-full">
              <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
                <div className="max-w-xl">
                  <h1 className="text-5xl md:text-7xl font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                    <span className="text-primary-500">韩国漫画网</span>
                  </h1>
                  <p className="text-lg md:text-xl text-white/80 leading-relaxed">
                    您的免费韩漫大全资源导航站，通过此漫画网址可便捷访问免费韩漫大全，并直接进行韩漫在线阅读
                  </p>
                </div>
                <a
                  href="/"
                  className="inline-flex items-center gap-3 px-8 py-3.5 rounded-full bg-white text-foreground-950 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer w-fit"
                >
                  <span>开始探索</span>
                  <span className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center flex-shrink-0">
                    <i className="ri-arrow-right-line text-white text-xs"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-12">
              <div className="lg:w-1/2">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    <strong>韩国漫画网</strong>成立于2023年，是国内领先的免费韩漫大全资源导航平台。
                    我们致力于为广大韩漫爱好者提供最便捷的韩漫在线阅读入口，通过一站式的漫画网址导航服务，
                    帮助读者快速找到优质的韩漫资源。
                  </p>
                  <p>
                    作为专业的韩漫导航站，我们收录了涵盖恋爱言情、热血动作、奇幻冒险、搞笑日常、悬疑惊悚、
                    都市剧情等多个分类的优质韩漫作品。无论是热门连载还是经典完结，
                    您都可以通过我们提供的漫画网址快速访问。
                  </p>
                  <p>
                    我们深知寻找优质韩漫内容的过程有时会让人感到繁琐，因此韩国漫画网以简洁高效的设计理念，
                    为您打造了直观的分类导航和智能推荐系统，让韩漫在线阅读变得更加轻松愉快。
                  </p>
                </div>
              </div>

              <div className="lg:w-1/2 bg-accent-100/80 rounded-lg p-10 flex items-center justify-center">
                <div className="text-center max-w-sm">
                  <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-accent-500 flex items-center justify-center">
                    <i className="ri-book-read-line text-2xl text-background-50"></i>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    我们相信，每一部优秀的韩漫都值得被更多读者发现。
                    韩国漫画网愿成为您探索韩漫世界的起点站。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                用户口碑
              </h2>
              <p className="text-sm text-foreground-600">来自韩漫爱好者的真实评价</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-50 rounded-lg p-6">
                <div className="flex items-center gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  "之前找韩漫资源总是很费劲，自从用了韩国漫画网，分类特别清晰，想看的漫画几秒钟就能找到入口。强烈推荐给所有韩漫爱好者！"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-user-line text-primary-500 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-foreground-950">漫画迷小王</p>
                    <p className="text-xs text-foreground-500">韩漫资深读者</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-lg p-6">
                <div className="flex items-center gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  "作为韩漫入门新手，这个网站的分类导读和推荐文章帮了我大忙。现在每天都会上来看看有没有新更新的漫画，已经成为了我的日常。"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-user-line text-accent-500 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-foreground-950">新晋韩漫迷</p>
                    <p className="text-xs text-foreground-500">大学生读者</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-lg p-6">
                <div className="flex items-center gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  "界面简洁干净，没有任何乱七八糟的广告，加载速度也很快。最喜欢的还是热门排行功能，总能帮我发现一些没看过的好作品。"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center">
                    <i className="ri-user-line text-secondary-500 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-foreground-950">设计师小李</p>
                    <p className="text-xs text-foreground-500">视觉设计从业者</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-12">
              <div className="lg:w-1/2">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
                  联系我们
                </h2>
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-500 text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h3>
                      <p className="text-sm text-foreground-600">hello@rldcigr.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-wechat-line text-accent-500 text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-1">微信公众号</h3>
                      <p className="text-sm text-foreground-600">搜索"韩国漫画网"关注我们</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-question-answer-line text-secondary-500 text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-1">工作时间</h3>
                      <p className="text-sm text-foreground-600">周一至周五 9:00 - 18:00</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:w-1/2">
                <div className="bg-background-100 rounded-lg p-8">
                  <h3 className="text-lg font-semibold text-foreground-950 mb-6">给我们留言</h3>
                  <form className="space-y-4">
                    <div>
                      <label htmlFor="about-name" className="block text-xs text-foreground-600 mb-1.5">姓名</label>
                      <input
                        id="about-name"
                        name="name"
                        type="text"
                        className="w-full bg-transparent border-b border-foreground-300 px-2 py-2 text-sm text-foreground-950 placeholder:text-foreground-400 outline-none focus:border-primary-500 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="about-email" className="block text-xs text-foreground-600 mb-1.5">邮箱</label>
                      <input
                        id="about-email"
                        name="email"
                        type="email"
                        className="w-full bg-transparent border-b border-foreground-300 px-2 py-2 text-sm text-foreground-950 placeholder:text-foreground-400 outline-none focus:border-primary-500 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="about-message" className="block text-xs text-foreground-600 mb-1.5">留言内容</label>
                      <textarea
                        id="about-message"
                        name="message"
                        rows={3}
                        className="w-full bg-transparent border-b border-foreground-300 px-2 py-2 text-sm text-foreground-950 placeholder:text-foreground-400 outline-none focus:border-primary-500 transition-colors resize-none"
                        placeholder="请输入您的留言"
                      ></textarea>
                    </div>
                    <button
                      type="submit"
                      className="px-8 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm hover:border-primary-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      发送留言
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}